// Input Box Placeholder
function fnremove(arg,val)	{
	if (arg.value == '') {arg.value = val}
}	
function fnshow(arg,val)	{
	if (arg.value == val) {arg.value = ''}
}

$(document).ready(function () {		
	
	jsUpdateSize(); 	
 
});

// responsive filter table 
$(window).resize(function(){	
	jsUpdateSize();	
});
function jsUpdateSize()
{
	var width = $(window).width();
    var height = $(window).height();	
	if(width<=767)
	{
		$("#filterOptions").addClass("filter-opp");
		$("#filterOptions.filter-opp").hide();		
	}
	else{
		$("#filterOptions").removeClass("filter-opp");
		$("#filterOptions").show();
	}
}

$("#filter-name, .select-arw").click(function()
	{				
	$("#filterOptions.filter-opp").slideToggle();
	});
	
	$("#filterOptions li a").click(function()
	{
		$("#filter-name a.select-txt").html($(this).html());
		$("#filterOptions.filter-opp").slideUp();
});






